import { render } from "./DeliveryNoteCommentComponent.vue?vue&type=template&id=5e041637"
import script from "./DeliveryNoteCommentComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteCommentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__